export class PatientRelatedStaff {

    static readonly type = '[patStaffIds] patStaffIds';

    constructor(public payload: {userIds:any,
        // userName:string,
        // roleId:any,
        // roleName:string,
        // userInternalId:any
    }) {
    }
}


